<script setup lang="ts">
const { setPageSeo } = useSeo()
const { getAllFormations } = useFormations()

const { data: formations } = await useAsyncData('sitemap-formations', () => getAllFormations())

await setPageSeo({
  title: 'Plan du Site',
  description: 'Plan du site de l\'école OXO à Narbonne : formations, projets étudiants, actualités, ateliers d\'été, candidature et contact.'
})
</script>

<template>
  <div class="pt-32 pb-24 bg-slate-50 dark:bg-oxo-dark min-h-screen">
    <div class="container mx-auto px-6 max-w-4xl">
      <h1 class="font-display font-bold text-4xl mb-12 text-slate-900 dark:text-white">Plan du Site</h1>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-12">
        
        <!-- Main Navigation -->
        <div>
          <h2 class="text-2xl font-bold mb-6 text-oxo-red border-b border-gray-200 dark:border-white/10 pb-2">Navigation Principale</h2>
          <ul class="space-y-4 text-lg">
            <li><NuxtLink to="/" class="hover:text-oxo-red transition">Accueil</NuxtLink></li>
            <li>
                <NuxtLink to="/ecole" class="hover:text-oxo-red transition font-semibold">L'École</NuxtLink>
                <ul class="ml-6 mt-2 space-y-2 text-base text-gray-600 dark:text-gray-400">
                    <li><NuxtLink to="/ecole#vision" class="hover:text-oxo-red">Vision</NuxtLink></li>
                    <li><NuxtLink to="/ecole#valeurs" class="hover:text-oxo-red">Nos Valeurs</NuxtLink></li>
                    <li><NuxtLink to="/ecole#pedagogie" class="hover:text-oxo-red">Pédagogie</NuxtLink></li>
                    <li><NuxtLink to="/ecole#equipe" class="hover:text-oxo-red">Équipe</NuxtLink></li>
                    <li><NuxtLink to="/ecole#histoire" class="hover:text-oxo-red">Histoire</NuxtLink></li>
                </ul>
            </li>
            <li>
                <span class="font-semibold text-slate-900 dark:text-white">Formations</span>
                <ul v-if="formations && formations.length > 0" class="ml-6 mt-2 space-y-2 text-base text-gray-600 dark:text-gray-400">
                    <li v-for="fmt in formations" :key="fmt.slug">
                      <NuxtLink :to="`/formations/${fmt.slug}`" class="hover:text-oxo-red">{{ fmt.title }}</NuxtLink>
                    </li>
                </ul>
            </li>
            <li><NuxtLink to="/projets" class="hover:text-oxo-red transition">Projets Étudiants</NuxtLink></li>
            <li><NuxtLink to="/actus" class="hover:text-oxo-red transition">Actualités</NuxtLink></li>
            <li><NuxtLink to="/candidature" class="hover:text-oxo-red transition font-bold text-oxo-red">Candidature</NuxtLink></li>
            <li><NuxtLink to="/faq" class="hover:text-oxo-red transition">FAQ</NuxtLink></li>
            <li><NuxtLink to="/contact" class="hover:text-oxo-red transition">Contact</NuxtLink></li>
          </ul>
        </div>

        <!-- Legal -->
        <div>
          <h2 class="text-2xl font-bold mb-6 text-oxo-red border-b border-gray-200 dark:border-white/10 pb-2">Informations Légales</h2>
          <ul class="space-y-4 text-lg">
            <li><NuxtLink to="/mentions-legales" class="hover:text-oxo-red transition">Mentions Légales</NuxtLink></li>
            <li><NuxtLink to="/cgu" class="hover:text-oxo-red transition">Conditions Générales d'Utilisation</NuxtLink></li>
            <li><NuxtLink to="/politique-confidentialite" class="hover:text-oxo-red transition">Politique de Confidentialité</NuxtLink></li>
          </ul>
        </div>

      </div>
    </div>
  </div>
</template>
